module.exports = __webpack_public_path__ + "img/slider-18.b53d9a57.jpg";